import React, { useState, useEffect, useRef, memo } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import {
    Modal,
    CardContent,
    CardHeader,
    Table,
    TableBody,
    TableCell,
    TableRow,
    Tab,
    Tabs,
    Tooltip,
    IconButton,
    Avatar,
    Box,
} from "@mui/material";

import Badge from "@mui/material/Badge";
import SubjectIcon from "@mui/icons-material/Subject";
// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React examples
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { useNavigate } from "react-router-dom";

import CrudService from "services/cruds-service";
import { ParamValuesChartForHolyKel } from "../ParamChart";
import DataTable from "examples/Tables/DataTable";
import ServiceRequestDataTable from "examples/Tables/ServiceRequestDataTable";
import moment from "moment";
import CollapsibleTable from "examples/Tables/ExpandTable";
import MDAlert from "components/MDAlert";
import GoogleMapComponent from "examples/Maps";
import { useMediaQuery } from "react-responsive";
import breakpoints from "assets/theme/base/breakpoints";
import { useWebSocket } from "context/WebSocketContext";
import { toast } from "react-toastify";
import JsonTree from "cruds/campaign/modal/jsontree";
import { show_device_setting } from "utils/constant";
import Visibility from '@mui/icons-material/Visibility';
import { fieldMapping } from "utils/constant";
import { serviceRequestStatusColor } from "utils/constant";
import {
    calculateFullDate,
    capitalizeWords,
    cond,
    deepCopy,
    deviceFields,
    formatNumber,
    formatValue
} from './utils';
import { } from './services';
import {
    DynamicDataTable,
    RenderTR,
    StackSkeleton,
    StyledBadge,
    StyledProgress,
    TableSection,
    devStyle,
} from './misc';
import LogsTable from "../table-view/logsTable";
import EventsTable from "../table-view/eventsTable";
import { useMaterialUIController } from "context";
import { setDarkMode } from "context";
import { setLayout } from "context";

const PublicGateway = ({ deviceId, channels = [], default_channel = '1' }) => {
    const [, dispatch] = useMaterialUIController();
    const id = deviceId;
    const navigate = useNavigate();
    const serviceRequestSelectedTab = localStorage.getItem("serviceRequestTab");

    const [name, setName] = useState({
        text: "",
        error: false,
        textError: "",
    });
    const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });

    const [paramValues, setParamValues] = useState([]);
    const [percent, setPercent] = useState(0);
    const [paramValue, setParamValue] = useState();
    const [device, setDevice] = useState();
    const [tableData, setTableData] = useState([]);
    const [serviceStatusUpdate, setServiceStatusUpdate] = useState("");
    const [deviceStatusName, setDeviceStatusName] = useState("");
    const [expandedIndexArray, setExpandedIndexArray] = useState([
        true,
        true,
        true,
        ...Array(6).fill(false),
    ]);
    const [isShare, setShare] = useState(false);
    const [selectedTab, setSelectedTab] = useState(
        parseInt(serviceRequestSelectedTab)
    );

    const [openViewModal, setOpenViewModal] = useState(false);
    const [alert, setAlert] = useState();
    const [alertTableData, setAlertTableData] = useState([]);

    const [alertRules, setAlertRules] = useState([]);
    const [eventTableData, setEventTableData] = useState([]);
    const [alertRuleTableData, setAlertRuleTableData] = useState([]);
    const [serviceRequestTableData, setServiceRequestTableData] = useState([]);

    /////////// service request ////////////
    const [dataTableUpdate, setDataTableUpdate] = useState("");

    const [notification, setNotification] = useState({
        value: false,
        text: "",
    });

    const [pillbarColor, setPillbarColor] = useState("rgb(38, 40, 51);");
    const [activeAlerts, setActiveAlerts] = useState([]);
    const [activeServiceRequest, setActiveServiceRequest] = useState(null);
    const [openModal, setOpenModal] = useState(false);
    const [loader, setLoader] = useState(false);
    const [gps, setGps] = useState({ latitude: "", longitude: "", edit: false });
    const [deviceUpdated, setDeviceUpdated] = useState("");
    const [tabsOrientation, setTabsOrientation] = useState("horizontal");
    const [reportType, setReportType] = useState({});
    const [wsEmit, setEmit] = useState(1);
    ////////////////// Device Thresholds /////////////////////
    const [selectedChannelThresholds, setSelectedChannelThresholds] = useState([]);

    ///////////////// Device Setup ////////////////
    const [deviceSetupFields, setDeviceSetupFields] = useState(deepCopy(deviceFields));
    const [navbarTitle, setNavbarTitle] = useState("");
    const [titleIcon, setTitleIcon] = useState(null)
    const [openJsonTree, setJsonTree] = useState(false)
    const [rawDataValue, setRawDataValue] = useState({})
    const [isAttributeRequired, setIsAttributeRequired] = useState(false)
    const [selectedMode, setSelectedMode] = useState(null)
    const [parameters, setParameter] = useState([])
    const [selectedLogInfo, setSelectedLogInfo] = useState(null)
    const { serviceRequestData, alertData, holyKelData } = useWebSocket();
    const [notifyAlert, setNotifyAlert] = useState(null)
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const countRef = useRef(0);
    const [defaultChannel, setDefaultChannel] = useState(default_channel);
    const [analysisData, setAnalysisData] = useState(null);

    useEffect(() => {
        if (id && holyKelData) {
            if (holyKelData.device_id == id) {
                updateDevice(holyKelData.data)
            }
        }
    }, [id, holyKelData]);

    useEffect(() => {
        if (id && alertData) {
            if (alertData.device_id == id) {
                updateAlert(alertData.alert, alertData.type)
            }
        }
    }, [id, alertData]);

    useEffect(() => {
        if (id && serviceRequestData) {
            if (serviceRequestData.device_id == id) {
                checkActiveServiceRequest();
            }
        }
    }, [id, serviceRequestData]);

    useEffect(() => {
        if (!id) return;
        setPillbarColor("rgb(38, 40, 51);");
        (async () => {
            try {
                setLoader(true);
                setDarkMode(dispatch, true)
                setLayout(dispatch, "page");
                const res = await CrudService.getPublicDeviceView(id);

                setDevice(res?.data);
                let icons = res?.data?.attributes?.EntityAddressItem?.Icon
                setTitleIcon(icons?.class_name)

                // Channel Based Thresholds
                const channelBsThreshold = res.data.deviceThresholds.filter(e => e.channel_number === Number(defaultChannel))
                setSelectedChannelThresholds(channelBsThreshold)

                if (res?.data?.reportTypes) {
                    let obj = {};
                    for (let report of res?.data?.reportTypes) {
                        obj[report.report_type_identifier] = report.report_type_name;
                    }
                    setReportType(obj);
                }
                const deviceParameter = await CrudService.getDeviceParameter();
                setParameter(() => [...deviceParameter.data])
                setName({ text: res.data.attributes?.name });
                setShare(res.data.attributes?.PublicShareDevice?.is_public ?? false);
                setSelectedMode(res.data.attributes.DeviceMode)
                let lastRecord;

                setParamValues(res?.data?.monitorParameterValues);
                if (res?.data?.latestWebhookData) {
                    lastRecord = res?.data?.latestWebhookData?.device_value;
                    lastRecord = { data: lastRecord?.channels?.[defaultChannel], ...lastRecord }
                    setParamValue(lastRecord);
                    setDeviceStatusName(res?.data?.latestWebhookData?.StatusType?.status_name); // TODO: changes
                    setDeviceUpdated(lastRecord?.last_updated ?? lastRecord?.timestamp);
                    localStorage.setItem(
                        "device_params",
                        JSON.stringify(lastRecord)
                    );
                    setAnalysisData(res?.data?.latestWebhookData?.analysis_data ?? null)
                    setPercent(lastRecord?.channels?.[defaultChannel]?.fill_percentage || 0);
                } else {
                    setLoader(false);
                    setNotifyAlert(`There is no logs data available for this device`)
                    return
                }

                const deviceSetupFields = res.data.itemAttributeValues.reduce(
                    (acc, item) => {
                        const fieldName = fieldMapping[item.attribute_id];
                        if (fieldName) {
                            acc[fieldName] = item.value;
                        }
                        return acc;
                    },
                    {}
                );
                let isAttributeRequired = Object.entries(deviceSetupFields).filter((e) => !['latitude', 'longitude'].includes(e[0])).some((e) => e[1] == '')
                setIsAttributeRequired(isAttributeRequired)
                setDeviceSetupFields(deviceSetupFields);

                setLoader(false);

                const deviceAlertsRes = await CrudService.getDeviceActiveAlerts(id, defaultChannel);
                let alertData = deviceAlertsRes?.data?.alerts?.reverse()
                setActiveAlerts(alertData);

                checkActiveServiceRequest();
                if (selectedTab === 4) {
                    serviceRequestList(res?.data?.attributes?.EntityAddressItem?.address_item_id)
                }

                // let deviceThresholds = res?.data?.deviceThresholds;
                for (let deviceThreshold of channelBsThreshold) {
                    if ([1, 26].includes(deviceThreshold.threshold_type_id)) {
                        let color = "rgb(38, 40, 51);";
                        let comparison_operator_id = deviceThreshold.comparison_operator_id;
                        const parameterName =
                            deviceThreshold?.DeviceParameter?.parameter_name;

                        const parameterMapping = {
                            percent_level: "percent_level",
                            Temperature: "enclosure_temperature",
                            product_level: "inch_level",
                            measured_height: "measured_height",
                        };

                        const propertyKey = parameterMapping[parameterName];
                        const parameterValue = parseInt(
                            lastRecord?.device_data?.[propertyKey]
                        );
                        const thresholdValue = parseInt(deviceThreshold.threshold_value);

                        if (propertyKey === undefined) {
                            console.error(`Unknown parameter name: ${parameterName}`);
                            return;
                        }

                        switch (parseInt(comparison_operator_id)) {
                            case 1:
                                color =
                                    parameterValue === thresholdValue
                                        ? "#d32f2f"
                                        : "rgb(38, 40, 51);";
                                break;
                            case 2:
                                color =
                                    parameterValue !== thresholdValue
                                        ? "#d32f2f"
                                        : "rgb(38, 40, 51);";
                                break;
                            case 3:
                                color =
                                    parameterValue < thresholdValue
                                        ? "#d32f2f"
                                        : "rgb(38, 40, 51);";
                                break;
                            case 4:
                                color =
                                    parameterValue <= thresholdValue
                                        ? "#d32f2f"
                                        : "rgb(38, 40, 51);";
                                break;
                            case 5:
                                color =
                                    parameterValue > thresholdValue
                                        ? "#d32f2f"
                                        : "rgb(38, 40, 51);";
                                break;
                            case 6:
                                color =
                                    parameterValue >= thresholdValue
                                        ? "#d32f2f"
                                        : "rgb(38, 40, 51);";
                                break;
                            default:
                                color = "rgb(38, 40, 51);";
                                break;
                        }

                        setPillbarColor(color);
                    }
                }
                if (alertData?.length > 0) {
                    setPillbarColor(alertData[0]?.AlertType?.BadgeDetail?.font_color_hex)
                }
            } catch (err) {
                if (err.status == 400) {
                    navigate("/user-profile");
                }
                console.error(err);
            }
        })();

        return () => resetAllState();
    }, [id, dataTableUpdate, serviceStatusUpdate, wsEmit, defaultChannel]);

    useEffect(() => {
        if (selectedTab == 1) {
            allAlerts(page, rowsPerPage)
        }
        if (selectedTab === 2) {
            allEvents()
        }
        if (selectedTab === 3) {
            // alertRulesList()
        }
        if (selectedTab === 4) {
            // serviceRequestList()
        }
    }, [id, selectedTab, page, rowsPerPage, reportType])

    function resetAllState() {
        setName({ text: "", error: false, textError: "" });
        setParamValues([]);
        setPercent(0);
        setParamValue(undefined);
        setDevice(undefined);
        setTableData([]);
        setServiceStatusUpdate("");
        setDeviceStatusName("");
        setExpandedIndexArray([true, true, true, ...Array(6).fill(false)]);
        setShare(false);
        setSelectedTab(parseInt(serviceRequestSelectedTab) || 0);
        setOpenViewModal(false);
        setAlert(undefined);
        setAlertTableData([]);
        setAlertRules([]);
        setEventTableData([]);
        setAlertRuleTableData([]);
        setServiceRequestTableData([]);
        setDataTableUpdate("");
        setNotification({ value: false, text: "" });
        setPillbarColor("rgb(38, 40, 51);");
        setActiveAlerts([]);
        setActiveServiceRequest(null);
        setOpenModal(false);
        setLoader(false);
        setGps({ latitude: "", longitude: "", edit: false });
        setDeviceUpdated("");
        setTabsOrientation("horizontal");
        setReportType({});
        setEmit(1);
        setDeviceSetupFields(deepCopy(deviceFields));
        setNavbarTitle("");
        setTitleIcon(null);
        setJsonTree(false);
        setRawDataValue({});
        setIsAttributeRequired(false);
        setSelectedMode(null);
        setParameter([]);
        setSelectedLogInfo(null);
        setNotifyAlert(null);
    }

    async function checkActiveServiceRequest() {
        try {
            const serviceAlertsRes = await CrudService.getActiveServiceRequest(id);
            setActiveServiceRequest(serviceAlertsRes?.data);
        } catch (err) {
            console.error('checkActiveServiceRequest', err)
        }
    }

    async function allAlerts(page, rowsPerPage) {
        try {
            let resp = await CrudService.getDeviceAlerts(id, page, rowsPerPage, defaultChannel);
            let alertFilter = getAlertRows(resp.data, percent);
            setAlertTableData(alertFilter);
            countRef.current = resp?.pagination?.total ?? resp?.count
        } catch (error) {
            console.error('allAlerts', error)
        }
    }

    async function allEvents() {
        try {
            let resp = await CrudService.getDeviceEvent(id);
            if (resp?.data) {
                let eventList = resp.data.reverse()
                const eventRows = getEventRows(eventList)
                setEventTableData(eventRows);
            }
        } catch (error) {
            console.error('allEvents', error)
        }
    }

    async function alertRulesList() {
        try {
            const resp = await CrudService.getAlertRules({ id });
            if (resp.data) {
                setAlertRules(resp.data);
            }
        } catch (error) {
            console.error('alertRules', error)
        }
    }

    async function serviceRequestList(address_id = null) {
        // TODO: issue here addrss item id
        let address_item_id = address_id ?? device?.attributes?.EntityAddressItem?.address_item_id;
        if (address_item_id) {
            const resp = await CrudService.getServiceRequests(address_item_id);
            if (resp.data) {
                let requests = getServiceRequestRows(resp.data)
                setServiceRequestTableData(requests);
            }
        }
    }

    async function updateDevice(data) {
        let latestRecord = data;
        latestRecord = { data: latestRecord?.channels?.[defaultChannel], ...latestRecord }
        setParamValue(latestRecord);
        setDeviceUpdated(latestRecord?.last_updated ?? latestRecord?.timestamp);
        setPercent(data?.channels?.[defaultChannel]?.fill_percentage || 0);
    }

    async function updateAlert(data, type) {
        if (type === 'Heal') {
            const deviceAlertsRes = await CrudService.getDeviceActiveAlerts(id, defaultChannel);
            let alertData = deviceAlertsRes?.data?.alerts?.reverse()
            setActiveAlerts(alertData);
            if (alertData?.length > 0) {
                setPillbarColor(alertData[0]?.AlertType?.BadgeDetail?.font_color_hex)
            } else {
                setPillbarColor("rgb(38, 40, 51);")
            }
        } else {
            setActiveAlerts([data]);
            setPillbarColor(data?.AlertType?.BadgeDetail?.font_color_hex)
        }
    }

    useEffect(() => {
        if (alertRules?.length) {
            let rules = getAlertRuleRows(alertRules)
            setAlertRuleTableData(rules);
        }
    }, [alertRules])

    useEffect(() => {
        let timer = null
        if (notification.value === true) {
            timer = setTimeout(() => {
                setNotification({
                    value: false,
                    text: "",
                });
            }, 5000);
        }
        return () => timer ? clearTimeout(timer) : ''
    }, [notification]);

    useEffect(() => {
        function handleScroll() {
            if (window.scrollY > 100) {
                setNavbarTitle(device?.attributes?.name || ""); // Set device name when scrolled down
            } else {
                setNavbarTitle(""); // Remove when scrolled up
            }
        }

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [device?.attributes?.name]);

    useEffect(() => {
        // A function that sets the orientation state of the tabs.
        function handleTabsOrientation() {
            return window.innerWidth < breakpoints.values.sm
                ? setTabsOrientation("vertical")
                : setTabsOrientation("horizontal");
        }

        /** 
         The event listener that's calling the handleTabsOrientation function when resizing the window.
        */
        window.addEventListener("resize", handleTabsOrientation);

        // Call the handleTabsOrientation function to set the state with the initial value.
        handleTabsOrientation();

        // Remove event listener on cleanup
        return () => window.removeEventListener("resize", handleTabsOrientation);
    }, [tabsOrientation]);

    const getRows = (info) => {
        info.sort((a, b) => b.id - a.id);
        let updatedInfo = info.map((row, index) => {
            let previousIndex;
            const channel = row.data?.channels?.[defaultChannel]
            if (!channel) {
                return null
            }
            if (info.length - 1 == index) {
                previousIndex = index;
            } else {
                previousIndex = index + 1;
            }
            const previous_percent_level = info[previousIndex]?.data?.channels?.[defaultChannel]?.fill_percentage ?? 0
            let check_drop = channel?.fill_percentage - previous_percent_level;
            // check_drop = Math.abs(check_drop);
            let percent_level_drop = check_drop < 1 ? Math.abs(check_drop).toFixed(0) : 0;
            let percent_level_increase = check_drop > 0 ? check_drop.toFixed(0) : 0;
            return {
                ...row,
                id: row?.id,
                actual_fluid_height: channel?.actual_fluid_height ?? 0,
                calibrated_level: channel?.calibrated_level ?? 0,
                raw_level: channel?.raw_level ?? 0,
                usable_height: channel?.usable_height ?? 0,
                fill_percentage: channel?.fill_percentage ?? 0,
                percent_level_drop: percent_level_drop,
                percent_level_increase: percent_level_increase,
                previous_percent_level: previous_percent_level,
                volume_level: formatNumber(channel?.volume_level ?? 0),
                date: row?.created_at,
            };
        });
        return updatedInfo.filter(Boolean);
    };

    const dataTableData = {
        columns: [
            { Header: "ID", accessor: "id", show: true },
            {
                Header: "Fluid Height",
                accessor: "actual_fluid_height",
                width: "10%",
                show: true,
            },
            {
                Header: "Calibrated Level",
                accessor: "calibrated_level",
                width: "10%",
                show: true,
            },
            {
                Header: "Raw level",
                accessor: "raw_level",
                width: "10%",
                show: true,
            },
            {
                Header: "Usable Height",
                accessor: "usable_height",
                width: "10%",
            },
            {
                Header: "Percent Level",
                accessor: "fill_percentage",
                width: "15%",
                show: true,
            },
            {
                Header: "Percent Level Drop",
                accessor: "percent_level_drop",
                width: "15%",
            },
            {
                Header: "Percent Level Increase",
                accessor: "percent_level_increase",
                width: "15%",
                show: true,
            },
            {
                Header: "Previous Percent Level",
                accessor: "previous_percent_level",
                width: "15%",
                show: true,
            },
            {
                Header: "Volume Level",
                accessor: "volume_level",
                width: "15%",
                show: true,
            },
            {
                Header: "Date",
                accessor: "date",
                show: true,
                isSortedDesc: true,
                isSorted: true,
                Cell: (info) => {
                    return (
                        <div
                            style={{
                                whiteSpace: "normal",
                                maxWidth: "300px",
                                wordWrap: "break-word",
                                wordBreak: "break-word",
                            }}
                        >
                            {moment(info.cell.row.original.date).format(
                                "MMMM DD, YYYY h:mm:ss A"
                            )}
                        </div>
                    );
                },
            },
            {
                Header: "Action",
                accessor: "",
                show: true,
                isSorted: false,
                Cell: (info) => {
                    return (
                        <div
                            style={{
                                padding: '5px'
                            }}
                        >
                            <IconButton onClick={(e) => clickLogInfoHandler(e, info.cell.row.original.data)}>
                                <Visibility />
                            </IconButton>
                            {/* <MDButton variant="outlined" color="info" onClick={(e) => clickLogInfoHandler(e, info.cell.row.original.data)}>View</MDButton> */}
                        </div>
                    );
                },
            },
        ],
        rows: tableData, // Assuming tableData is your original data array
    };

    const clickServiceRequestViewHandler = (e, service_request_id) => {
        e.stopPropagation();
        navigate(`/service-request-detail/${service_request_id}`);
    };

    const getAlertRuleRows = (info) => {
        let updatedInfo = info.map((row) => {
            let frequency = "";
            if (row.attributes?.frequency && row.attributes?.frequency != null) {
                frequency =
                    row.attributes?.frequency +
                    " min" +
                    (row.attributes?.frequency > 1 ? "(s)" : "");
            }

            let rule_type =
                row.attributes?.module_id === 12
                    ? "Alert"
                    : row.attributes?.module_id === 13
                        ? "Service Request"
                        : "";

            const event_type_id = row.attributes?.event_type_id;
            let message_template_name = "";
            if (event_type_id == 14) {
                message_template_name = row.attributes?.SendgridTemplate?.name;
            }
            if (event_type_id == 15) {
                message_template_name = row.attributes?.MessageTemplate?.name;
            }
            return {
                id: row?.id,
                rule_type: rule_type,
                alert_type: row.attributes?.AlertType?.type_name,
                alert_type_category: row.attributes?.AlertType?.category,
                alert_sub_type: row.attributes?.AlertSubType?.sub_type_name,
                event_type: row.attributes?.EventType?.name,
                message_template_name: message_template_name,
                address: row.attributes?.ContactAddress?.contact_address,
                send_to_type: row.attributes?.SendToType?.send_to_type_name,
                frequency: frequency,
                status_text:
                    row.attributes?.StatusOption?.StatusType?.status_name || "",
                status: (
                    <Badge
                        color={
                            row.attributes?.StatusOption?.BadgeDetail?.color || "primary"
                        }
                        variant={row.attributes?.StatusOption?.BadgeDetail?.variant}
                        badgeContent={row.attributes?.StatusOption?.StatusType?.status_name}
                        style={{ marginLeft: "30px" }}
                    ></Badge>
                ),
            };
        });

        return updatedInfo;
    };

    const alertRuledataTableData = {
        columns: [
            { Header: "ID", accessor: "id", show: true },
            { Header: "Status Badge", accessor: "status", show: true },
            { Header: "Status ", accessor: "status_text", show: false },

            { Header: "Rule Type", accessor: "rule_type", show: true },
            { Header: "Alert Type", accessor: "alert_type", show: true },
            {
                Header: "Alert Type Category",
                accessor: "alert_type_category",
                show: true,
            },
            { Header: "Alert Sub Type", accessor: "alert_sub_type", show: true },
            { Header: "Event Type", accessor: "event_type", show: true },
            {
                Header: "Message Template Name",
                accessor: "message_template_name",
                show: true,
            },
            { Header: "Address", accessor: "address", show: true },
            { Header: "Send Type", accessor: "send_to_type", show: true },
            { Header: "Frequency", accessor: "frequency", show: true }
        ],
        rows: alertRuleTableData, // Assuming tableData is your original data array
    };

    const getEventRows = (info) => {
        let updatedInfo = info.map((row) => {
            return {
                id: row?.event_id,
                alert_type: row?.AlertType?.type_name,
                parameter_name: row?.DeviceParameter?.parameter_name,
                percent_value: row?.percent_change,
                prev_value: row?.previous_value,
                current_value: row?.new_value,
                volume: row?.volume_change,
                date: row?.event_timestamp,
                raw_data: row?.WebhookRawDatum ? row?.WebhookRawDatum?.value : {}
            };
        });

        return updatedInfo;
    };

    const openJsonTreedata = (e, value) => {
        e.stopPropagation();
        setRawDataValue(value)
        setJsonTree(true)
    }

    const eventdataTableData = {
        columns: [
            {
                Header: "ID",
                accessor: "id",
                show: true,
                Cell: (info) => {
                    return <a onClick={(e) => openJsonTreedata(e, info.cell.row.original.raw_data)}>{info.value}</a>
                }
            },
            { Header: "Type", accessor: "alert_type", show: true },
            { Header: "Parameter Name", accessor: "parameter_name", show: true },
            { Header: "Current Value", accessor: "current_value", show: true },
            { Header: "Previous Value", accessor: "prev_value", show: true },
            {
                Header: "Percent Change",
                accessor: "percent_value",
                show: true,
                Cell: (info) => `${Number(info.value).toFixed(0)}%`,
            },
            {
                Header: "Volume Change ( Gallons )",
                accessor: "volume",
                show: true,
                Cell: (info) => `${Number(info.value).toFixed(0)}`,
            },
            {
                Header: "Date",
                accessor: "date",
                show: true,
                isSortedDesc: true,
                isSorted: true,
                Cell: (info) => {
                    return (
                        <div
                            style={{
                                whiteSpace: "normal",
                                maxWidth: "300px",
                                wordWrap: "break-word",
                                wordBreak: "break-word",
                            }}
                        >
                            {moment(info.cell.row.original.date).format(
                                "MMMM DD, YYYY h:mm:ss A"
                            )}
                        </div>
                    );
                },
            },
        ],
        rows: eventTableData, // Assuming tableData is your original data array
    };

    const getServiceRequestRows = (info) => {
        let updatedInfo = info.map((row) => {
            return {
                id: row.attributes?.service_request_id,
                user: row.attributes?.user?.name,
                entityAddressItem: row.attributes?.EntityAddressItem?.name,
                provider: row.attributes?.Provider?.provider_name,
                serviceItem: row.attributes?.ServiceItem?.item_name,
                request_date: row.attributes?.request_date,
                status: row.attributes?.StatusOption,
                status_text:
                    row.attributes?.StatusOption?.StatusType?.status_name || "",
            };
        });

        return updatedInfo;
    };

    const serviceRequestdataTableData = {
        columns: [
            { Header: "ID", accessor: "id", width: "12rem", show: true },
            {
                Header: "Status Badge",
                accessor: "",
                width: "12rem",
                show: true,
                Cell: (info) => {
                    return (
                        <StyledBadge
                            color={
                                info.cell.row.original?.status?.BadgeDetail?.color || "primary"
                            }
                            variant={
                                info.cell.row.original?.status?.BadgeDetail?.variant ||
                                "contained"
                            }
                            badgeContent={
                                info.cell.row.original.status?.StatusType?.status_name
                            }
                            style={{ marginLeft: "30px" }}
                        ></StyledBadge>
                    );
                },
            },
            { Header: "Status", accessor: "status_text", width: "12rem", show: true },

            {
                Header: "Entity Address Item",
                accessor: "entityAddressItem",
                width: "12rem",
                show: true,
            },
            { Header: "Provider", accessor: "provider", width: "12rem", show: true },
            {
                Header: "Service Item",
                accessor: "serviceItem",
                width: "12rem",
                show: true,
            },
            {
                Header: "Requested Date",
                accessor: "request_date",
                width: "12rem",
                show: true,
            },
            { Header: "User", accessor: "user", width: "12rem", show: true },
            {
                Header: "actions",
                disableSortBy: true,
                accessor: "",
                width: "12rem",
                show: true,
                Cell: (info) => {
                    return (
                        <MDBox display="flex" alignItems="center">
                            <Tooltip title="View Service Request">
                                <IconButton
                                    onClick={(e) =>
                                        clickServiceRequestViewHandler(e, info.cell.row.original.id)
                                    }
                                >
                                    <MDTypography>
                                        <SubjectIcon />
                                    </MDTypography>
                                </IconButton>
                            </Tooltip>
                        </MDBox>
                    );
                },
            },
        ],
        rows: serviceRequestTableData, // Assuming tableData is your original data array
    };

    const getAlertRows = (info, percent) => {
        let updatedInfo = info.map((row) => {
            const createdAt = row.attributes.created_at
                ? moment(row.attributes.created_at).format("MMMM DD, YYYY h:mm:ss A")
                : "";
            const updatedAt = row.attributes.updated_at
                ? moment(row.attributes.updated_at).format("MMMM DD, YYYY h:mm:ss A")
                : "";
            const subType = row.attributes.is_parent
                ? "Alert Created"
                : row.attributes.is_healed
                    ? "Alert Healed"
                    : "Alert Resent";

            return {
                id: row.id,
                device_id: row.attributes?.device_id,
                alert_type_id: row.attributes?.alert_type_id,
                alert_type: row.attributes?.AlertType?.type_name,
                alert_type_category: row.attributes?.AlertType?.category,
                device: row.attributes.Device?.name,
                parameter_name: row.attributes?.DeviceParameter?.label ?? '',
                sub_type: subType,
                is_parent: row.attributes?.is_parent,
                threshold_value: row.attributes.threshold,
                exceed_value: row.attributes.exceed_value,
                // TODO: fix current value
                current_value: !['', null, 'null', undefined, NaN].includes(row.current_value) ? row.current_value : percent,
                created_at: createdAt,
                updated_at: updatedAt,
                status_text:
                    row.attributes?.StatusOption?.StatusType?.status_name || "",
                status: (
                    <Badge
                        color={
                            row.attributes?.StatusOption?.BadgeDetail?.color || "primary"
                        }
                        variant={row.attributes?.StatusOption?.BadgeDetail?.variant}
                        badgeContent={row.attributes?.StatusOption?.StatusType?.status_name}
                        style={{ marginLeft: "30px" }}
                    ></Badge>
                ),
            };
        });
        return updatedInfo;
    };

    const alertColumns = [
        { Header: "ID", accessor: "id", width: "5%", show: true },
        { Header: "Status Badge", accessor: "status", width: "5%", show: true },
        { Header: "Status", accessor: "status_text", show: false },
        { Header: "Alert Type", accessor: "alert_type", width: "10%", show: true },
        { Header: 'Parameter', accessor: 'parameter_name', width: '10%', show: true },
        { Header: 'Threshold Value', accessor: 'threshold_value', width: '5%' },
        { Header: 'Exceed Value', accessor: 'exceed_value', width: '5%' },
        { Header: 'Current Value', accessor: 'current_value', width: '5%' },
        {
            Header: "Alert Category",
            accessor: "alert_type_category",
            width: "10%",
            show: true,
        },
        { Header: "Sub Type", accessor: "sub_type", width: "8%", show: true },
        { Header: "Created At", accessor: "created_at", width: "15%", show: true },
        { Header: "Updated At", accessor: "updated_at", width: "15%", show: true },
        {
            Header: "actions",
            disableSortBy: true,
            accessor: "actions",
            show: true,
        },
    ];

    const clickViewHandler = async (id, value) => {
        let data = await CrudService.getAlert(id);
        setAlert(data);
        setOpenViewModal(true);
    };

    const StyledLinearProgress = StyledProgress(pillbarColor)

    const handleExpand = (index) => {
        setExpandedIndexArray((prevArray) =>
            prevArray.map((item, idx) => (idx === index ? !item : item))
        );
    };

    const handleTabChange = (event, newValue) => {
        setSelectedTab(newValue);
        localStorage.setItem("serviceRequestTab", newValue);
    };

    function copyToClipboard(text) {
        navigator.clipboard.writeText(text)
            .then(() => {
                toast.info("Copied!")
            })
            .catch((error) => {
                console.error("Failed to copy text:", error);
            });
    }

    const cardStyle = (index) => ({
        display: "flex",
        flexDirection: "column",
        ...(expandedIndexArray[index] && { minHeight: "100%" }),
    });

    const styles = devStyle(isTabletOrMobile)

    const handleViewClose = () => {
        setOpenViewModal(false);
    };

    // This function will handle the removal of the alert when clicked
    const handleClose = async (alertId, alertTypeId, deviceId) => {
        // Filter out the alert with the matching id
        const updatedAlerts = activeAlerts.filter(
            (alert) => alert.alert_id !== alertId
        );
        setActiveAlerts(updatedAlerts);
        const payload = {
            deviceId: deviceId,
            alertTypeId: alertTypeId,
        };
        await CrudService.updateNotificationStatus(payload);
    };

    const checkAllNotification = (alerts) => {
        let isAllNotification = false;
        alerts.forEach((alert) => {
            if (alert?.AlertType?.category != "notice") {
                isAllNotification = true;
                return;
            }
        });
        return isAllNotification;
    };

    const openModalFn = (type) => {
        if (type == "device") {
            setGps({
                latitude: paramValue?.latitude,
                longitude: paramValue?.longitude,
            });
        } else if (type == "item") {
            setGps({
                latitude: deviceSetupFields?.latitude,
                longitude: deviceSetupFields?.longitude,
                edit: true,
            });
        } else if (type == "itemButton") {
            setGps({
                latitude: device?.attributes?.EntityAddressItem?.Address?.latitude,
                longitude: device?.attributes?.EntityAddressItem?.Address?.longitude,
                edit: true,
            });
        } else {
            setGps({
                latitude: device?.attributes?.EntityAddressItem?.Address?.latitude,
                longitude: device?.attributes?.EntityAddressItem?.Address?.longitude,
            });
        }
        setOpenModal(true);
    };


    const clickLogInfoHandler = (e, data) => {
        e.stopPropagation()
        if (data) {
            setSelectedLogInfo(data)
        } else {
            window.alert('No data')
        }
    }

    return (
        <div style={{ width: '100%', height: '100vh', padding: '0 1rem' }}>
            <DashboardNavbar title={navbarTitle} titleIcon={titleIcon} showBreadCrumbs={false} />
            {notification.value && (
                <MDAlert
                    color={notification.bgColor}
                    my="20px"
                    sx={{
                        position: "sticky",
                        top: { md: "100px", xs: "50px" },
                        zIndex: "10000",
                    }}
                >
                    <MDTypography variant="body2" color="white">
                        {notification.text || ""}
                    </MDTypography>
                </MDAlert>
            )}

            <MDBox mt={0} mb={9}>
                <Grid justifyContent="center">
                    <Grid item xs={12} lg={8}>
                        <MDBox mt={0} mb={0} textAlign="center">
                            <MDBox mb={1}>
                                <MDTypography variant="h3" fontWeight="bold">
                                    {titleIcon ? <i className={titleIcon} style={{ fontSize: "24px" }}></i> : ''} {device?.attributes?.name}{" "}
                                    {activeAlerts.length != 0 &&
                                        checkAllNotification(activeAlerts) ? (
                                        // <i
                                        //   className="fas fa-triangle-exclamation"
                                        //   style={{ fontSize: "24px", color: "#d32f2f" }}
                                        // ></i>
                                        <i
                                            className={activeAlerts[0].AlertType?.Icon?.class_name ?? "fas fa-triangle-exclamation"}
                                            style={{ fontSize: "24px", color: `${activeAlerts[0]?.AlertType?.BadgeDetail?.font_color_hex ?? "#d32f2f"}` }}
                                        ></i>
                                    ) : (
                                        ""
                                    )}
                                </MDTypography>
                                <Box
                                    sx={{
                                        width: '100%',
                                        overflowX: 'auto',
                                        '@media (max-width:600px)': {
                                            pb: 1.5,
                                        },
                                    }}
                                >
                                    <Tabs
                                        value={String(defaultChannel)}
                                        onChange={(e, val) => {
                                            e.stopPropagation();
                                            setDefaultChannel(val);
                                        }}
                                        aria-label="channel tabs"
                                        indicatorColor="secondary"
                                        textColor="inherit"
                                        variant="scrollable"
                                        scrollButtons="auto"
                                        allowScrollButtonsMobile
                                        sx={{
                                            minHeight: 48,
                                            "& .MuiTabs-flexContainer": {
                                                flexWrap: "nowrap"
                                            },
                                            "& .MuiTab-root": {
                                                minWidth: { xs: 90, sm: 100, md: 120 }, // Responsive minWidth
                                                paddingX: { xs: 0.5, sm: 2 }, // Reduce horizontal padding for mobile
                                                fontSize: { xs: '0.78rem', sm: '0.92rem', md: '1rem' },
                                            }
                                        }}
                                    >
                                        {channels.map((e, i) => (
                                            <Tab
                                                key={`channels_${e.channel_number}`}
                                                label={
                                                    <span style={{
                                                        whiteSpace: "nowrap",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                        display: "inline-block",
                                                        maxWidth: 400, // prevent channel label overflowing on mobile
                                                        '@media (minWidth:600px)': {
                                                            maxWidth: 90, // allow label to expand on desktop
                                                        }
                                                    }}>
                                                        {`${e.channel_name} (${e.channel_number})`}
                                                    </span>
                                                }
                                                value={String(e.channel_number)}
                                                sx={{
                                                    maxWidth: { xs: 120, sm: 200 },
                                                    minHeight: { xs: 36, sm: 48 },
                                                }}
                                            />
                                        ))}
                                    </Tabs>
                                </Box>


                                {
                                    isAttributeRequired ?
                                        <div
                                            style={{
                                                display: "flex",
                                                position: "relative",
                                                padding: "5px",
                                                marginBottom: "10px",
                                                border: `1px solid green`,
                                                alignItems: "center",
                                                backgroundColor: "#d1ffd6",
                                            }}
                                        >
                                            <MDTypography
                                                variant="h6"
                                                style={{
                                                    fontSize: "12px",
                                                    color: "green",
                                                    marginLeft: "10px",
                                                }}
                                            >
                                                Device Setup Attribute is Required
                                            </MDTypography>
                                        </div> : <></>
                                }
                                {activeAlerts.map((alert) => (
                                    <div
                                        style={{
                                            display: "flex",
                                            position: "relative",
                                            padding: "5px",
                                            marginBottom: "10px",
                                            border: `1px solid ${alert?.AlertType?.BadgeDetail?.border_color_hex ?? "green"}`,
                                            alignItems: "center",
                                            backgroundColor: alert?.AlertType?.BadgeDetail?.background_color_hex ?? "#d1ffd6",
                                        }}
                                    >
                                        {/* Close button */}
                                        {alert?.AlertType?.category == "notice" && (
                                            <button
                                                style={{
                                                    position: "absolute",
                                                    top: "5px",
                                                    right: "5px",
                                                    background: "transparent",
                                                    border: "none",
                                                    fontSize: "16px",
                                                    cursor: "pointer",
                                                    color: "black",
                                                }}
                                                onClick={() =>
                                                    handleClose(
                                                        alert?.alert_id,
                                                        alert?.alert_type_id,
                                                        alert?.device_id
                                                    )
                                                } // Replace with your close function
                                            >
                                                &times;
                                            </button>
                                        )}
                                        <MDTypography
                                            variant="h6"
                                            style={{
                                                fontSize: "12px",
                                                color: alert?.AlertType?.BadgeDetail?.font_color_hex ?? "green",
                                                marginLeft: "10px",
                                            }}
                                        >
                                            <i
                                                className={alert?.AlertType?.Icon?.class_name}
                                                style={{
                                                    marginRight: "5px",
                                                    fontSize: "16px",
                                                    color: alert?.AlertType?.BadgeDetail?.font_color_hex ?? "green",
                                                }}
                                            ></i>{" "}
                                            {alert?.AlertType?.type_name} -{" "}
                                            {alert?.AlertType?.description} &middot;{" "}
                                            {moment(alert?.created_at).format(
                                                "MMMM Do YYYY, h:mm:ss A"
                                            )}
                                        </MDTypography>
                                    </div>
                                ))}
                                {
                                    activeServiceRequest &&
                                    <div
                                        style={{
                                            display: "flex",
                                            position: "relative",
                                            padding: "5px",
                                            marginBottom: "10px",
                                            border: `1px solid ${activeServiceRequest?.StatusOption?.BadgeDetail?.font_color ?? 'green'}`,
                                            alignItems: "center",
                                            backgroundColor: serviceRequestStatusColor(activeServiceRequest?.StatusOption?.BadgeDetail?.color),
                                        }}
                                    >
                                        <MDTypography
                                            variant="h6"
                                            style={{
                                                fontSize: "12px",
                                                color: activeServiceRequest?.StatusOption?.BadgeDetail?.font_color ?? 'green',
                                                marginLeft: "10px",
                                            }}
                                        >
                                            {'Service ' + activeServiceRequest?.StatusOption?.StatusType?.status_name} -{" "}
                                            {activeServiceRequest?.StatusOption?.StatusType?.description} &middot;{" "}
                                            {moment(activeServiceRequest?.created_at).format(
                                                "MMMM Do YYYY, h:mm:ss A"
                                            )}
                                        </MDTypography>
                                    </div>
                                }
                                {
                                    notifyAlert &&
                                    <div
                                        style={{
                                            display: "flex",
                                            position: "relative",
                                            padding: "5px",
                                            marginBottom: "10px",
                                            border: `1px solid yellow`,
                                            alignItems: "center",
                                            backgroundColor: '#ffff00ba'
                                            // backgroundColor: serviceRequestStatusColor(activeServiceRequest?.StatusOption?.BadgeDetail?.color),
                                        }}
                                    >
                                        <MDTypography
                                            variant="h6"
                                            style={{
                                                fontSize: "12px",
                                                color: 'white',
                                                marginLeft: "10px",
                                            }}
                                        >
                                            <i
                                                className='fa fa-bell'
                                                style={{
                                                    marginRight: "5px",
                                                    fontSize: "16px",
                                                    color: "#fff",
                                                }}
                                            ></i>{" "}
                                            {notifyAlert}
                                        </MDTypography>
                                    </div>
                                }
                            </MDBox>
                        </MDBox>
                        <Card>
                            <MDBox>
                                <MDBox display="flex" flexDirection="column" px={3} my={2}>
                                    <MDBox>
                                        <MDTypography>Level</MDTypography>
                                        <MDBox style={{ position: "relative" }}>
                                            <StyledLinearProgress
                                                variant="determinate"
                                                value={percent}
                                            />
                                            <MDBox
                                                position="absolute"
                                                top={0}
                                                left={0}
                                                right={0}
                                                bottom={0}
                                                display="flex"
                                                alignItems="center"
                                                justifyContent="center"
                                                color={percent == '-' ? "white" : percent > 49 ? "white" : "black"}
                                            >
                                                <MDTypography variant="body2" color="textSecondary">
                                                    {percent == '-' ? percent : `${percent}%`}
                                                </MDTypography>
                                            </MDBox>
                                        </MDBox>
                                    </MDBox>
                                    <ParamValuesChartForHolyKel paramValues={paramValues} pillbarColor={pillbarColor} channel_id={defaultChannel} />
                                    <MDBox mb={3}>
                                        <Grid container spacing={3}>
                                            {[
                                                {
                                                    title: "Device Information",
                                                    icon: "fas fa-info-circle",
                                                },
                                                { title: "Current Data", icon: "fas fa-chart-line" },
                                                { title: "Monitor", icon: "fas fa-tachometer-alt" },
                                            ].map((item, index) => (
                                                <Grid item xs={12} lg={4} key={index}>
                                                    <Card style={cardStyle(index)}>
                                                        <CardHeader
                                                            title={
                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                    }}
                                                                >
                                                                    <i
                                                                        className={item.icon}
                                                                        style={{ marginRight: "8px" }}
                                                                    ></i>
                                                                    {item.title}
                                                                </div>
                                                            }
                                                            style={{
                                                                // backgroundColor: "#f0f0f0",
                                                                borderBottom: "1px solid #e0e0e0",
                                                                cursor: "pointer",
                                                            }}
                                                            onClick={() => handleExpand(index)}
                                                        />
                                                        {expandedIndexArray[index] && (
                                                            <CardContent
                                                                style={
                                                                    isTabletOrMobile
                                                                        ? { padding: "16px", flex: 1 }
                                                                        : { flex: 1 }
                                                                }
                                                            >
                                                                {index === 0 && (
                                                                    <>
                                                                        {!loader ? (
                                                                            <Table
                                                                                style={{
                                                                                    ...styles.table,
                                                                                    marginTop: "5px",
                                                                                    boxShadow:
                                                                                        "0 2px 4px rgba(0, 0, 0, 0.1)",
                                                                                }}
                                                                            >
                                                                                <TableBody>
                                                                                    <TableRow>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                <strong>Device Name:</strong>
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                {name?.text}
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                    </TableRow>
                                                                                    <TableRow>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                <strong>Device Type:</strong>
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                {
                                                                                                    device?.attributes?.DeviceType
                                                                                                        ?.type_name
                                                                                                }
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                    </TableRow>
                                                                                    <TableRow>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                <strong>Brand:</strong>
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                {
                                                                                                    device?.attributes
                                                                                                        ?.DeviceBrand?.brand_name
                                                                                                }
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                    </TableRow>
                                                                                    <TableRow>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                <strong>Model:</strong>
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                {
                                                                                                    device?.attributes
                                                                                                        ?.DeviceModel?.model_name
                                                                                                }
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                    </TableRow>
                                                                                    <TableRow>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                <strong>Item Type:</strong>
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                {
                                                                                                    device?.attributes
                                                                                                        ?.EntityAddressItem?.Item
                                                                                                        ?.ItemType?.type_name
                                                                                                }
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                    </TableRow>
                                                                                    <TableRow>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                <strong>
                                                                                                    Entity Address Item Id:
                                                                                                </strong>
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                {
                                                                                                    device?.attributes?.EntityAddressItem?.address_item_id
                                                                                                }
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                    </TableRow>
                                                                                    <TableRow>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                <strong>
                                                                                                    Entity Address Id:
                                                                                                </strong>
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                {
                                                                                                    device?.attributes
                                                                                                        ?.EntityAddressItem?.Address
                                                                                                        ?.address_id
                                                                                                }
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                    </TableRow>
                                                                                    <TableRow>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                <strong>Item Name:</strong>
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                {
                                                                                                    device?.attributes
                                                                                                        ?.EntityAddressItem?.name
                                                                                                }
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                    </TableRow>
                                                                                    <TableRow>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                <strong>Item Type:</strong>
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                {
                                                                                                    device?.attributes
                                                                                                        ?.EntityAddressItem?.Item
                                                                                                        ?.name
                                                                                                }
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                    </TableRow>
                                                                                    <TableRow>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                <strong>Address Name:</strong>
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                {
                                                                                                    device?.attributes
                                                                                                        ?.EntityAddressItem?.Address
                                                                                                        ?.name
                                                                                                }
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                    </TableRow>
                                                                                    <TableRow>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                <strong>Address:</strong>
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                {[
                                                                                                    device?.attributes
                                                                                                        ?.EntityAddressItem?.Address
                                                                                                        ?.street_address1,
                                                                                                    device?.attributes
                                                                                                        ?.EntityAddressItem?.Address
                                                                                                        ?.street_address2,
                                                                                                    [
                                                                                                        device?.attributes
                                                                                                            ?.EntityAddressItem
                                                                                                            ?.Address?.city,
                                                                                                        device?.attributes
                                                                                                            ?.EntityAddressItem
                                                                                                            ?.Address?.state,
                                                                                                        device?.attributes
                                                                                                            ?.EntityAddressItem
                                                                                                            ?.Address?.postal_code,
                                                                                                    ]
                                                                                                        .filter(Boolean)
                                                                                                        .join(", "),
                                                                                                ]
                                                                                                    .filter(Boolean)
                                                                                                    .join(", ")}
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                    </TableRow>
                                                                                    <TableRow>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                <strong>Status / Mode:</strong>
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                        <TableCell style={styles.cell}>
                                                                                            <MDTypography fontSize={1}>
                                                                                                {
                                                                                                    device?.attributes
                                                                                                        ?.StatusOption?.StatusType
                                                                                                        ?.status_name
                                                                                                } / {
                                                                                                    selectedMode?.mode_name
                                                                                                }
                                                                                            </MDTypography>
                                                                                        </TableCell>
                                                                                    </TableRow>
                                                                                    {deviceSetupFields?.latitude && (
                                                                                        <TableRow>
                                                                                            <TableCell style={styles.cell}>
                                                                                                <MDTypography fontSize={1}>
                                                                                                    <strong>
                                                                                                        Item Latitude:
                                                                                                    </strong>
                                                                                                </MDTypography>
                                                                                            </TableCell>
                                                                                            <TableCell
                                                                                                style={{
                                                                                                    ...styles.cell,
                                                                                                    cursor: "pointer",
                                                                                                }}
                                                                                                onClick={() =>
                                                                                                    openModalFn("item")
                                                                                                }
                                                                                            >
                                                                                                <MDTypography fontSize={1}>
                                                                                                    <a>
                                                                                                        {
                                                                                                            deviceSetupFields?.latitude
                                                                                                        }
                                                                                                    </a>
                                                                                                </MDTypography>
                                                                                            </TableCell>
                                                                                        </TableRow>
                                                                                    )}
                                                                                    {deviceSetupFields?.longitude && (
                                                                                        <TableRow>
                                                                                            <TableCell style={styles.cell}>
                                                                                                <MDTypography fontSize={1}>
                                                                                                    <strong>
                                                                                                        Item Longitude:
                                                                                                    </strong>
                                                                                                </MDTypography>
                                                                                            </TableCell>
                                                                                            <TableCell
                                                                                                style={{
                                                                                                    ...styles.cell,
                                                                                                    cursor: "pointer",
                                                                                                }}
                                                                                                onClick={() =>
                                                                                                    openModalFn("item")
                                                                                                }
                                                                                            >
                                                                                                <MDTypography fontSize={1}>
                                                                                                    <a>
                                                                                                        {
                                                                                                            deviceSetupFields?.longitude
                                                                                                        }
                                                                                                    </a>
                                                                                                </MDTypography>
                                                                                            </TableCell>
                                                                                        </TableRow>
                                                                                    )}
                                                                                </TableBody>
                                                                            </Table>
                                                                        ) : (
                                                                            <StackSkeleton />
                                                                        )}
                                                                    </>
                                                                )}
                                                                {index === 1 && (
                                                                    <>
                                                                        {loader && <StackSkeleton />}

                                                                        <Table
                                                                            style={{
                                                                                ...styles.table,
                                                                                marginTop: "5px",
                                                                                boxShadow:
                                                                                    "0 2px 4px rgba(0, 0, 0, 0.1)",
                                                                            }}
                                                                        >
                                                                            <TableBody>
                                                                                {!loader && (
                                                                                    <>
                                                                                        <TableRow>
                                                                                            <TableCell
                                                                                                style={styles.cell}
                                                                                            >
                                                                                                <MDTypography fontSize={1}>
                                                                                                    <strong>
                                                                                                        Fluid Height:
                                                                                                    </strong>
                                                                                                </MDTypography>
                                                                                            </TableCell>
                                                                                            <TableCell
                                                                                                style={styles.cell}
                                                                                            >
                                                                                                <MDTypography fontSize={1}>
                                                                                                    {paramValue?.data?.actual_fluid_height} Inches
                                                                                                </MDTypography>
                                                                                            </TableCell>
                                                                                        </TableRow>
                                                                                        <TableRow>
                                                                                            <TableCell style={styles.cell}>
                                                                                                <MDTypography fontSize={1}>
                                                                                                    <strong>
                                                                                                        Calibrated Level:
                                                                                                    </strong>
                                                                                                </MDTypography>
                                                                                            </TableCell>
                                                                                            <TableCell style={styles.cell}>
                                                                                                <MDTypography fontSize={1}>
                                                                                                    {paramValue?.data?.calibrated_level}
                                                                                                </MDTypography>
                                                                                            </TableCell>
                                                                                        </TableRow>
                                                                                        <TableRow>
                                                                                            <TableCell style={styles.cell}>
                                                                                                <MDTypography fontSize={1}>
                                                                                                    <strong>
                                                                                                        Percent Level:
                                                                                                    </strong>
                                                                                                </MDTypography>
                                                                                            </TableCell>
                                                                                            <TableCell style={styles.cell}>
                                                                                                <MDTypography fontSize={1}>
                                                                                                    {paramValue?.data?.fill_percentage}
                                                                                                </MDTypography>
                                                                                            </TableCell>
                                                                                        </TableRow>
                                                                                        <TableRow>
                                                                                            <TableCell style={styles.cell}>
                                                                                                <MDTypography fontSize={1}>
                                                                                                    <strong>
                                                                                                        Usable Height:
                                                                                                    </strong>
                                                                                                </MDTypography>
                                                                                            </TableCell>
                                                                                            <TableCell style={styles.cell}>
                                                                                                <MDTypography fontSize={1}>
                                                                                                    {paramValue?.data?.usable_height}
                                                                                                </MDTypography>
                                                                                            </TableCell>
                                                                                        </TableRow>
                                                                                        <TableRow>
                                                                                            <TableCell style={styles.cell}>
                                                                                                <MDTypography fontSize={1}>
                                                                                                    <strong>
                                                                                                        Volume:
                                                                                                    </strong>
                                                                                                </MDTypography>
                                                                                            </TableCell>
                                                                                            <TableCell style={styles.cell}>
                                                                                                <MDTypography fontSize={1}>
                                                                                                    {paramValue?.data?.volume_level} Gallons
                                                                                                </MDTypography>
                                                                                            </TableCell>
                                                                                        </TableRow>

                                                                                        {device?.attributes
                                                                                            ?.EntityAddressItem?.Address
                                                                                            ?.latitude && (
                                                                                                <TableRow>
                                                                                                    <TableCell style={styles.cell}>
                                                                                                        <MDTypography fontSize={1}>
                                                                                                            <strong>
                                                                                                                Address Latitude:
                                                                                                            </strong>
                                                                                                        </MDTypography>
                                                                                                    </TableCell>
                                                                                                    <TableCell
                                                                                                        style={{
                                                                                                            ...styles.cell,
                                                                                                            cursor: "pointer",
                                                                                                        }}
                                                                                                        onClick={() =>
                                                                                                            openModalFn("address")
                                                                                                        }
                                                                                                    >
                                                                                                        <MDTypography fontSize={1}>
                                                                                                            <a>
                                                                                                                {
                                                                                                                    device?.attributes
                                                                                                                        ?.EntityAddressItem
                                                                                                                        ?.Address?.latitude
                                                                                                                }
                                                                                                            </a>
                                                                                                        </MDTypography>
                                                                                                    </TableCell>
                                                                                                </TableRow>
                                                                                            )}
                                                                                        {device?.attributes
                                                                                            ?.EntityAddressItem?.Address
                                                                                            ?.longitude && (
                                                                                                <TableRow>
                                                                                                    <TableCell style={styles.cell}>
                                                                                                        <MDTypography fontSize={1}>
                                                                                                            <strong>
                                                                                                                Address Longitude:
                                                                                                            </strong>
                                                                                                        </MDTypography>
                                                                                                    </TableCell>
                                                                                                    <TableCell
                                                                                                        style={{
                                                                                                            ...styles.cell,
                                                                                                            cursor: "pointer",
                                                                                                        }}
                                                                                                        onClick={() =>
                                                                                                            openModalFn("address")
                                                                                                        }
                                                                                                    >
                                                                                                        <MDTypography fontSize={1}>
                                                                                                            <a>
                                                                                                                {
                                                                                                                    device?.attributes
                                                                                                                        ?.EntityAddressItem
                                                                                                                        ?.Address?.longitude
                                                                                                                }
                                                                                                            </a>
                                                                                                        </MDTypography>
                                                                                                    </TableCell>
                                                                                                </TableRow>
                                                                                            )}

                                                                                        <>
                                                                                            {paramValue?.parsed_ansi?.latitude &&
                                                                                                paramValue?.parsed_ansi?.latitude !=
                                                                                                0 && (
                                                                                                    <TableRow>
                                                                                                        <TableCell
                                                                                                            style={styles.cell}
                                                                                                        >
                                                                                                            <MDTypography
                                                                                                                fontSize={1}
                                                                                                            >
                                                                                                                <strong>
                                                                                                                    Device Latitude:
                                                                                                                </strong>
                                                                                                            </MDTypography>
                                                                                                        </TableCell>
                                                                                                        <TableCell
                                                                                                            style={{
                                                                                                                ...styles.cell,
                                                                                                                cursor: "pointer",
                                                                                                            }}
                                                                                                            onClick={() =>
                                                                                                                openModalFn("device")
                                                                                                            }
                                                                                                        >
                                                                                                            <MDTypography
                                                                                                                fontSize={1}
                                                                                                            >
                                                                                                                <a>
                                                                                                                    {Number(
                                                                                                                        paramValue?.parsed_ansi?.latitude
                                                                                                                    ).toFixed(8)}
                                                                                                                </a>
                                                                                                            </MDTypography>
                                                                                                        </TableCell>
                                                                                                    </TableRow>
                                                                                                )}
                                                                                            {paramValue?.parsed_ansi?.longitude &&
                                                                                                paramValue?.parsed_ansi?.longitude !=
                                                                                                0 && (
                                                                                                    <TableRow>
                                                                                                        <TableCell
                                                                                                            style={styles.cell}
                                                                                                        >
                                                                                                            <MDTypography
                                                                                                                fontSize={1}
                                                                                                            >
                                                                                                                <strong>
                                                                                                                    Device Longitude:
                                                                                                                </strong>
                                                                                                            </MDTypography>
                                                                                                        </TableCell>
                                                                                                        <TableCell
                                                                                                            style={{
                                                                                                                ...styles.cell,
                                                                                                                cursor: "pointer",
                                                                                                            }}
                                                                                                            onClick={() =>
                                                                                                                openModalFn("device")
                                                                                                            }
                                                                                                        >
                                                                                                            <MDTypography
                                                                                                                fontSize={1}
                                                                                                            >
                                                                                                                <a>
                                                                                                                    {Number(
                                                                                                                        paramValue?.parsed_ansi?.longitude
                                                                                                                    ).toFixed(8)}
                                                                                                                </a>
                                                                                                            </MDTypography>
                                                                                                        </TableCell>
                                                                                                    </TableRow>
                                                                                                )}
                                                                                            {paramValue?.parsed_ansi?.longitude != 0 &&
                                                                                                paramValue?.parsed_ansi?.latitude != 0 &&
                                                                                                paramValue?.last_updated && (
                                                                                                    <TableRow>
                                                                                                        <TableCell
                                                                                                            style={styles.cell}
                                                                                                        >
                                                                                                            <MDTypography
                                                                                                                fontSize={1}
                                                                                                            >
                                                                                                                <strong>
                                                                                                                    Last Updated:
                                                                                                                </strong>
                                                                                                            </MDTypography>
                                                                                                        </TableCell>
                                                                                                        <TableCell
                                                                                                            style={styles.cell}
                                                                                                        >
                                                                                                            <MDTypography
                                                                                                                fontSize={1}
                                                                                                            >
                                                                                                                {moment(
                                                                                                                    paramValue?.last_updated
                                                                                                                ).format(
                                                                                                                    "MMMM Do YYYY, h:mm:ss a"
                                                                                                                )}
                                                                                                            </MDTypography>
                                                                                                        </TableCell>
                                                                                                    </TableRow>
                                                                                                )}
                                                                                        </>
                                                                                    </>
                                                                                )}
                                                                            </TableBody>
                                                                        </Table>
                                                                    </>
                                                                )}
                                                                {index === 2 && (
                                                                    <>
                                                                        {loader && <StackSkeleton />}
                                                                        {!loader && (
                                                                            <MDBox>
                                                                                <table className="table table-borderless">
                                                                                    <tbody>
                                                                                        <tr>
                                                                                            <RenderTR
                                                                                                th={"Name"}
                                                                                                td={device?.monitor}
                                                                                                styles={styles}
                                                                                            />
                                                                                        </tr>
                                                                                        <tr>
                                                                                            {device?.monitor_status
                                                                                                ?.StatusType?.status_name && (
                                                                                                    <RenderTR
                                                                                                        th={"Status"}
                                                                                                        styles={styles}
                                                                                                        td={
                                                                                                            <Badge
                                                                                                                color={
                                                                                                                    device?.monitor_status
                                                                                                                        ?.BadgeDetail
                                                                                                                        ?.color || "primary"
                                                                                                                }
                                                                                                                variant={
                                                                                                                    device?.monitor_status
                                                                                                                        ?.BadgeDetail?.variant
                                                                                                                }
                                                                                                                badgeContent={
                                                                                                                    device?.monitor_status
                                                                                                                        ?.StatusType
                                                                                                                        ?.status_name
                                                                                                                }
                                                                                                                style={{
                                                                                                                    marginLeft: "30px",
                                                                                                                }}
                                                                                                            ></Badge>
                                                                                                        }
                                                                                                    />
                                                                                                )}
                                                                                        </tr>
                                                                                        <tr>
                                                                                            {device?.monitor_frequency && (
                                                                                                <RenderTR
                                                                                                    styles={styles}
                                                                                                    th={"Frequency"}
                                                                                                    td={`${device?.monitor_frequency ??
                                                                                                        ""
                                                                                                        } ${device?.monitor_time_unit ??
                                                                                                        ""
                                                                                                        }`}
                                                                                                />
                                                                                            )}
                                                                                        </tr>
                                                                                        <tr>
                                                                                            {device?.monitor_last_updated && (
                                                                                                <RenderTR
                                                                                                    styles={styles}
                                                                                                    th={"Last Updated"}
                                                                                                    td={moment(
                                                                                                        device?.monitor_last_updated
                                                                                                    ).format(
                                                                                                        "MMMM Do YYYY, h:mm:ss a"
                                                                                                    )}
                                                                                                />
                                                                                            )}
                                                                                        </tr>
                                                                                    </tbody>
                                                                                </table>

                                                                                {selectedChannelThresholds.map(
                                                                                    (threshold, thresholdIndex) => (
                                                                                        <Table
                                                                                            key={thresholdIndex + 3}
                                                                                            style={{
                                                                                                ...styles.table,
                                                                                                marginTop: "5px",
                                                                                                boxShadow:
                                                                                                    "0 2px 4px rgba(0, 0, 0, 0.1)",
                                                                                            }}
                                                                                        >
                                                                                            <TableBody>
                                                                                                <TableRow>
                                                                                                    <TableCell
                                                                                                        style={styles.cell}
                                                                                                    >
                                                                                                        <MDTypography fontSize={1}>
                                                                                                            <span
                                                                                                                style={{
                                                                                                                    fontWeight: "700",
                                                                                                                }}
                                                                                                            >
                                                                                                                {" "}
                                                                                                                Alert Type:
                                                                                                            </span>
                                                                                                        </MDTypography>
                                                                                                    </TableCell>
                                                                                                    <TableCell
                                                                                                        style={styles.cell}
                                                                                                    >
                                                                                                        <MDTypography fontSize={1}>
                                                                                                            {
                                                                                                                threshold?.AlertType
                                                                                                                    ?.type_name
                                                                                                            }
                                                                                                        </MDTypography>
                                                                                                    </TableCell>
                                                                                                </TableRow>
                                                                                                <TableRow>
                                                                                                    <TableCell
                                                                                                        style={styles.cell}
                                                                                                    >
                                                                                                        <MDTypography fontSize={1}>
                                                                                                            <span
                                                                                                                style={{
                                                                                                                    fontWeight: "700",
                                                                                                                }}
                                                                                                            >
                                                                                                                {" "}
                                                                                                                Parameter
                                                                                                            </span>
                                                                                                        </MDTypography>
                                                                                                    </TableCell>
                                                                                                    <TableCell
                                                                                                        style={styles.cell}
                                                                                                    >
                                                                                                        <MDTypography fontSize={1}>
                                                                                                            {
                                                                                                                threshold
                                                                                                                    ?.DeviceParameter
                                                                                                                    ?.label
                                                                                                            }
                                                                                                        </MDTypography>
                                                                                                    </TableCell>
                                                                                                </TableRow>
                                                                                                <TableRow>
                                                                                                    <TableCell
                                                                                                        style={styles.cell}
                                                                                                    >
                                                                                                        <MDTypography fontSize={1}>
                                                                                                            <span
                                                                                                                style={{
                                                                                                                    fontWeight: "700",
                                                                                                                }}
                                                                                                            >
                                                                                                                {" "}
                                                                                                                Comparison Operator:
                                                                                                            </span>
                                                                                                        </MDTypography>
                                                                                                    </TableCell>
                                                                                                    <TableCell
                                                                                                        style={styles.cell}
                                                                                                    >
                                                                                                        <MDTypography fontSize={1}>
                                                                                                            {
                                                                                                                threshold
                                                                                                                    ?.ComparisonOperator
                                                                                                                    ?.label
                                                                                                            }
                                                                                                        </MDTypography>
                                                                                                    </TableCell>
                                                                                                </TableRow>
                                                                                                <TableRow>
                                                                                                    <TableCell
                                                                                                        style={styles.cell}
                                                                                                    >
                                                                                                        <MDTypography fontSize={1}>
                                                                                                            <span
                                                                                                                style={{
                                                                                                                    fontWeight: "700",
                                                                                                                }}
                                                                                                            >
                                                                                                                {" "}
                                                                                                                Threshold Comparison
                                                                                                                Value:
                                                                                                            </span>
                                                                                                        </MDTypography>
                                                                                                    </TableCell>
                                                                                                    <TableCell
                                                                                                        style={styles.cell}
                                                                                                    >
                                                                                                        <MDTypography fontSize={1}>
                                                                                                            {
                                                                                                                threshold?.threshold_value
                                                                                                            }
                                                                                                        </MDTypography>
                                                                                                    </TableCell>
                                                                                                </TableRow>
                                                                                            </TableBody>
                                                                                        </Table>
                                                                                    )
                                                                                )}
                                                                            </MDBox>
                                                                        )}
                                                                    </>
                                                                )}
                                                            </CardContent>
                                                        )}
                                                    </Card>
                                                </Grid>
                                            ))}
                                        </Grid>
                                    </MDBox>

                                    <MDBox mb={3}>
                                        <Grid container spacing={3}>
                                            {[
                                                { title: "Transmission", icon: "fas fa-signal" },
                                                { title: "Analytics", icon: "fas fa-chart-diagram" },
                                                { title: "Providers", icon: "fas fa-truck" },
                                            ].map((item, index) => (
                                                <Grid item xs={12} lg={4} key={index + 3}>
                                                    <Card style={cardStyle(index + 3)}>
                                                        <CardHeader
                                                            title={
                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                    }}
                                                                >
                                                                    <i
                                                                        className={item.icon}
                                                                        style={{ marginRight: "8px" }}
                                                                    ></i>
                                                                    {item.title}
                                                                </div>
                                                            }
                                                            style={{
                                                                // backgroundColor: "#f0f0f0",
                                                                borderBottom: "1px solid #e0e0e0",
                                                                cursor: "pointer",
                                                            }}
                                                            onClick={() => handleExpand(index + 3)}
                                                        />
                                                        {expandedIndexArray[index + 3] && (
                                                            <CardContent style={{ flex: 1 }}>
                                                                {index === 0 && (
                                                                    <>
                                                                        {!loader ? (
                                                                            <Table
                                                                                style={{
                                                                                    ...styles.table,
                                                                                    marginTop: "5px",
                                                                                    boxShadow:
                                                                                        "0 2px 4px rgba(0, 0, 0, 0.1)",
                                                                                }}
                                                                            >
                                                                                <TableBody>
                                                                                    {!loader && (
                                                                                        <>
                                                                                            {deviceStatusName && (
                                                                                                <TableRow>
                                                                                                    <TableCell
                                                                                                        style={styles.cell}
                                                                                                    >
                                                                                                        <MDTypography fontSize={1}>
                                                                                                            <strong>Status:</strong>
                                                                                                        </MDTypography>
                                                                                                    </TableCell>
                                                                                                    <TableCell
                                                                                                        style={styles.cell}
                                                                                                    >
                                                                                                        {deviceStatusName ===
                                                                                                            "Working" ? (
                                                                                                            <Badge
                                                                                                                variant="gradient"
                                                                                                                badgeContent={
                                                                                                                    deviceStatusName
                                                                                                                }
                                                                                                                color="success"
                                                                                                                style={{
                                                                                                                    marginLeft: "40px",
                                                                                                                }}
                                                                                                            ></Badge>
                                                                                                        ) : deviceStatusName !==
                                                                                                            "" ? (
                                                                                                            <Badge
                                                                                                                variant="gradient"
                                                                                                                badgeContent={
                                                                                                                    deviceStatusName
                                                                                                                }
                                                                                                                color="error"
                                                                                                                style={{
                                                                                                                    marginLeft: "-60px",
                                                                                                                    width: "120px",
                                                                                                                }}
                                                                                                            ></Badge>
                                                                                                        ) : (
                                                                                                            ""
                                                                                                        )}
                                                                                                    </TableCell>
                                                                                                </TableRow>
                                                                                            )}
                                                                                            <TableRow>
                                                                                                <TableCell
                                                                                                    style={styles.cell}
                                                                                                >
                                                                                                    <MDTypography fontSize={1}>
                                                                                                        <strong>Signal Strength:</strong>
                                                                                                    </MDTypography>
                                                                                                </TableCell>
                                                                                                <TableCell
                                                                                                    style={styles.cell}
                                                                                                >
                                                                                                    <MDTypography fontSize={1}>
                                                                                                        {paramValue?.signal_strength ?? '-'} dBm
                                                                                                    </MDTypography>
                                                                                                </TableCell>
                                                                                            </TableRow>
                                                                                            <TableRow>
                                                                                                <TableCell
                                                                                                    style={styles.cell}
                                                                                                >
                                                                                                    <MDTypography fontSize={1}>
                                                                                                        <strong>Reported:</strong>
                                                                                                    </MDTypography>
                                                                                                </TableCell>
                                                                                                <TableCell
                                                                                                    style={styles.cell}
                                                                                                >
                                                                                                    <MDTypography fontSize={1}>
                                                                                                        {(() => {
                                                                                                            const time = moment(
                                                                                                                paramValue?.last_checked ??
                                                                                                                deviceUpdated
                                                                                                            );
                                                                                                            const dateFormat = "MMM Do YYYY, ";
                                                                                                            // If the hour is 12 PM or later, show 'PM'. Otherwise, omit 'AM'.
                                                                                                            const timeFormat = time.hour() >= 12 ? "h:mm A" : "h:mm";
                                                                                                            return time.format(dateFormat + timeFormat);
                                                                                                        })()}
                                                                                                    </MDTypography>
                                                                                                </TableCell>
                                                                                            </TableRow>
                                                                                            <TableRow>
                                                                                                <TableCell
                                                                                                    style={styles.cell}
                                                                                                >
                                                                                                    <MDTypography fontSize={1}>
                                                                                                        <strong>
                                                                                                            Last Updated:
                                                                                                        </strong>
                                                                                                    </MDTypography>
                                                                                                </TableCell>
                                                                                                <TableCell
                                                                                                    style={styles.cell}
                                                                                                >
                                                                                                    <MDTypography fontSize={1}>
                                                                                                        {moment(
                                                                                                            paramValue?.last_updated ??
                                                                                                            deviceUpdated
                                                                                                        ).fromNow()}
                                                                                                    </MDTypography>
                                                                                                </TableCell>
                                                                                            </TableRow>
                                                                                            {paramValue?.reportType && (
                                                                                                <TableRow>
                                                                                                    <TableCell
                                                                                                        style={styles.cell}
                                                                                                    >
                                                                                                        <MDTypography fontSize={1}>
                                                                                                            <strong>
                                                                                                                Report Type:
                                                                                                            </strong>
                                                                                                        </MDTypography>
                                                                                                    </TableCell>
                                                                                                    <TableCell
                                                                                                        style={styles.cell}
                                                                                                    >
                                                                                                        <MDTypography fontSize={1}>
                                                                                                            {
                                                                                                                reportType[
                                                                                                                paramValue?.reportType
                                                                                                                ]
                                                                                                            }
                                                                                                        </MDTypography>
                                                                                                    </TableCell>
                                                                                                </TableRow>
                                                                                            )}
                                                                                        </>
                                                                                    )}
                                                                                </TableBody>
                                                                            </Table>
                                                                        ) : (
                                                                            <StackSkeleton />
                                                                        )}
                                                                    </>
                                                                )}
                                                                {index === 1 && (
                                                                    <>
                                                                        {!loader && analysisData ? (
                                                                            <>
                                                                                {/* Last 24h Section */}
                                                                                <Box sx={{ marginBottom: 2 }}>
                                                                                    <TableSection
                                                                                        title="Last 24 Hours"
                                                                                        styles={styles}
                                                                                        rowData={[
                                                                                            {
                                                                                                label: "Percent Change",
                                                                                                value: analysisData[defaultChannel]?.last_24_hours?.percent_change ?? 0,
                                                                                                unit: "%",
                                                                                                renderType: "text",
                                                                                            },
                                                                                            {
                                                                                                label: "Level Change",
                                                                                                value: analysisData[defaultChannel]?.last_24_hours?.inch_change ?? 0,
                                                                                                unit: " inches",
                                                                                                renderType: "text",
                                                                                            },
                                                                                            {
                                                                                                label: "Volume Change",
                                                                                                value: analysisData[defaultChannel]?.last_24_hours?.volume_change ?? 0,
                                                                                                unit: " gal",
                                                                                                renderType: "text",
                                                                                            },
                                                                                        ]}
                                                                                    />
                                                                                </Box>

                                                                                {/* Last 7 Days Section */}
                                                                                <Box sx={{ marginBottom: 2 }}>
                                                                                    <TableSection
                                                                                        title="Last 7 Days"
                                                                                        styles={styles}
                                                                                        rowData={[
                                                                                            {
                                                                                                label: "Percent Change",
                                                                                                value: analysisData[defaultChannel]?.last_7_days?.percent_change ?? 0,
                                                                                                unit: "%",
                                                                                                renderType: "text",
                                                                                            },
                                                                                            {
                                                                                                label: "Level Change",
                                                                                                value: analysisData[defaultChannel]?.last_7_days?.inch_change ?? 0,
                                                                                                unit: " inches",
                                                                                                renderType: "text",
                                                                                            },
                                                                                            {
                                                                                                label: "Volume Change",
                                                                                                value: analysisData[defaultChannel]?.last_7_days?.volume_change ?? 0,
                                                                                                unit: " gal",
                                                                                                renderType: "text",
                                                                                            },
                                                                                        ]}
                                                                                    />
                                                                                </Box>

                                                                                {/* AI Analysis Section */}
                                                                                {device?.analysis && (
                                                                                    <Box sx={{ marginBottom: 2 }}>
                                                                                        <TableSection
                                                                                            title="AI Analysis"
                                                                                            styles={styles}
                                                                                            // rowData={Object.entries(device.analysis).map(([label, value]) => ({
                                                                                            //   label,
                                                                                            //   value,
                                                                                            //   renderType:
                                                                                            //     label === "Trend" || label === "Status" || label === "Anomalies" ? "icon" : "text",
                                                                                            // }))}
                                                                                            rowData={[
                                                                                                {
                                                                                                    label: "Trend",
                                                                                                    value:
                                                                                                        device?.analysis?.Trend,
                                                                                                    renderType: "icon",
                                                                                                },
                                                                                                {
                                                                                                    label: "Status",
                                                                                                    value:
                                                                                                        device?.analysis?.Status,
                                                                                                    renderType: "icon",
                                                                                                },
                                                                                                {
                                                                                                    label: `${capitalizeWords(
                                                                                                        device?.analysis[
                                                                                                        "Estimated Type"
                                                                                                        ] || ""
                                                                                                    )} Date`,
                                                                                                    value: ![
                                                                                                        0,
                                                                                                        null,
                                                                                                        undefined,
                                                                                                        "",
                                                                                                    ].includes(
                                                                                                        device?.analysis?.[
                                                                                                        "Estimated Time (Days)"
                                                                                                        ]
                                                                                                    )
                                                                                                        ? calculateFullDate(
                                                                                                            device.analysis[
                                                                                                            "Estimated Time (Days)"
                                                                                                            ]
                                                                                                        )
                                                                                                        : "None",
                                                                                                    renderType: "text",
                                                                                                },
                                                                                                {
                                                                                                    label: `Days Until ${capitalizeWords(
                                                                                                        device?.analysis[
                                                                                                        "Estimated Type"
                                                                                                        ] || ""
                                                                                                    )}`,
                                                                                                    value:
                                                                                                        device?.analysis?.[
                                                                                                        "Estimated Time (Days)"
                                                                                                        ],
                                                                                                    renderType: "text",
                                                                                                },
                                                                                                {
                                                                                                    label: "Estimated Type",
                                                                                                    value:
                                                                                                        device?.analysis?.[
                                                                                                        "Estimated Type"
                                                                                                        ],
                                                                                                    renderType: "text",
                                                                                                },
                                                                                                {
                                                                                                    label: "Anomalies",
                                                                                                    value:
                                                                                                        device?.analysis?.Anomalies,
                                                                                                    renderType: "icon",
                                                                                                },
                                                                                                {
                                                                                                    label:
                                                                                                        "Threshold Breach Prediction",
                                                                                                    value:
                                                                                                        device?.analysis?.[
                                                                                                        "Threshold Breach Prediction"
                                                                                                        ],
                                                                                                    renderType: "text",
                                                                                                },
                                                                                                {
                                                                                                    label: "Reason",
                                                                                                    value:
                                                                                                        device?.analysis?.[
                                                                                                        "Reason"
                                                                                                        ],
                                                                                                    renderType: "text",
                                                                                                },
                                                                                            ]}
                                                                                        />
                                                                                    </Box>
                                                                                )}
                                                                            </>
                                                                        ) : (
                                                                            <StackSkeleton />
                                                                        )}
                                                                    </>
                                                                )}

                                                                {index === 2 && (
                                                                    <>
                                                                        <MDBox>
                                                                            <Grid
                                                                                container
                                                                                justifyContent="space-between"
                                                                            >
                                                                                <Grid item>
                                                                                    <MDTypography variant="h6">
                                                                                        Provider
                                                                                    </MDTypography>
                                                                                </Grid>
                                                                                <Grid item>
                                                                                    <MDTypography variant="h6" mr={3}>
                                                                                        Share
                                                                                    </MDTypography>
                                                                                </Grid>
                                                                            </Grid>
                                                                            {!loader ? (
                                                                                <>
                                                                                    {device?.entityAddressItemProviders.map(
                                                                                        (provider) => (
                                                                                            <MDBox
                                                                                                key={provider?.association_id}
                                                                                                sx={{
                                                                                                    display: "flex",
                                                                                                    alignItems: "center",
                                                                                                    justifyContent:
                                                                                                        "space-between",
                                                                                                    width: "100%",
                                                                                                }}
                                                                                            >
                                                                                                <MDBox
                                                                                                    sx={{
                                                                                                        display: "flex",
                                                                                                        alignItems: "center",
                                                                                                    }}
                                                                                                >
                                                                                                    <Avatar
                                                                                                        src={
                                                                                                            provider?.Provider
                                                                                                                ?.logo_url
                                                                                                        }
                                                                                                        alt={
                                                                                                            provider?.Provider
                                                                                                                ?.provider_name
                                                                                                        }
                                                                                                        sx={{
                                                                                                            width: 60,
                                                                                                            height: 60,
                                                                                                        }}
                                                                                                    />
                                                                                                    <MDTypography ml={2}>
                                                                                                        {
                                                                                                            provider?.Provider
                                                                                                                ?.provider_name
                                                                                                        }
                                                                                                    </MDTypography>
                                                                                                </MDBox>
                                                                                            </MDBox>
                                                                                        )
                                                                                    )}
                                                                                </>
                                                                            ) : (
                                                                                <StackSkeleton />
                                                                            )}
                                                                        </MDBox>
                                                                    </>
                                                                )}
                                                            </CardContent>
                                                        )}
                                                    </Card>
                                                </Grid>
                                            ))}
                                        </Grid>
                                    </MDBox>

                                    <MDBox mb={3}>
                                        <Grid container spacing={3}>
                                            {[
                                                {
                                                    title: "Contact Detail",
                                                    icon: "fas fa-address-book",
                                                },
                                                {
                                                    title: "Device Setup",
                                                    icon: "fas fa-wrench",
                                                },
                                                { title: "Actions", icon: "fas fa-cogs" },
                                            ].map((item, index) => (
                                                <Grid item xs={12} lg={4} key={index + 6}>
                                                    <Card style={cardStyle(index + 6)}>
                                                        <CardHeader
                                                            title={
                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                    }}
                                                                >
                                                                    <i
                                                                        className={item.icon}
                                                                        style={{ marginRight: "8px" }}
                                                                    ></i>
                                                                    {item.title}
                                                                </div>
                                                            }
                                                            style={{
                                                                // backgroundColor: "#f0f0f0",
                                                                borderBottom: "1px solid #e0e0e0",
                                                                cursor: "pointer",
                                                            }}
                                                            onClick={() => handleExpand(index + 6)}
                                                        />
                                                        {expandedIndexArray[index + 6] && (
                                                            <CardContent
                                                                style={{
                                                                    flex: 1,
                                                                    display: "flex",
                                                                    flexDirection: "column",
                                                                }}
                                                            >
                                                                {index === 0 && (
                                                                    <>
                                                                        {!loader ? (
                                                                            <>
                                                                                {device &&
                                                                                    device.contacts &&
                                                                                    device.contacts.map(
                                                                                        (contact, contactindex) => (
                                                                                            <MDBox key={contactindex + 6}>
                                                                                                <Table
                                                                                                    style={{
                                                                                                        ...styles.table,
                                                                                                        marginTop: "5px",
                                                                                                        boxShadow:
                                                                                                            "0 2px 4px rgba(0, 0, 0, 0.1)",
                                                                                                    }}
                                                                                                >
                                                                                                    <TableBody>
                                                                                                        <TableRow>
                                                                                                            <TableCell
                                                                                                                style={styles.cell}
                                                                                                            >
                                                                                                                <MDTypography
                                                                                                                    fontSize={1}
                                                                                                                >
                                                                                                                    <span
                                                                                                                        style={{
                                                                                                                            fontWeight: "700",
                                                                                                                        }}
                                                                                                                    >
                                                                                                                        {" "}
                                                                                                                        Contact Name:{" "}
                                                                                                                    </span>
                                                                                                                </MDTypography>
                                                                                                            </TableCell>
                                                                                                            <TableCell
                                                                                                                style={styles.cell}
                                                                                                            >
                                                                                                                <MDTypography
                                                                                                                    fontSize={1}
                                                                                                                >
                                                                                                                    {`${contact?.Contact?.first_name} ${contact?.Contact?.last_name}`}
                                                                                                                </MDTypography>
                                                                                                            </TableCell>
                                                                                                        </TableRow>
                                                                                                        <TableRow>
                                                                                                            <TableCell
                                                                                                                style={styles.cell}
                                                                                                            >
                                                                                                                <MDTypography
                                                                                                                    fontSize={1}
                                                                                                                >
                                                                                                                    <span
                                                                                                                        style={{
                                                                                                                            fontWeight: "700",
                                                                                                                        }}
                                                                                                                    >
                                                                                                                        {" "}
                                                                                                                        Access Type:{" "}
                                                                                                                    </span>
                                                                                                                </MDTypography>
                                                                                                            </TableCell>
                                                                                                            <TableCell
                                                                                                                style={styles.cell}
                                                                                                            >
                                                                                                                <MDTypography
                                                                                                                    fontSize={1}
                                                                                                                >
                                                                                                                    {
                                                                                                                        contact?.access_type?.toUpperCase()
                                                                                                                    }
                                                                                                                </MDTypography>
                                                                                                            </TableCell>
                                                                                                        </TableRow>
                                                                                                        <TableRow>
                                                                                                            <TableCell
                                                                                                                style={styles.cell}
                                                                                                            >
                                                                                                                <MDTypography
                                                                                                                    fontSize={1}
                                                                                                                >
                                                                                                                    <span
                                                                                                                        style={{
                                                                                                                            fontWeight: "700",
                                                                                                                        }}
                                                                                                                    >
                                                                                                                        {" "}
                                                                                                                        Status:{" "}
                                                                                                                    </span>
                                                                                                                </MDTypography>
                                                                                                            </TableCell>
                                                                                                            <TableCell
                                                                                                                style={styles.cell}
                                                                                                            >
                                                                                                                <MDTypography
                                                                                                                    fontSize={1}
                                                                                                                >
                                                                                                                    {
                                                                                                                        contact?.Contact
                                                                                                                            ?.StatusOption
                                                                                                                            ?.StatusType
                                                                                                                            ?.status_name
                                                                                                                    }
                                                                                                                </MDTypography>
                                                                                                            </TableCell>
                                                                                                        </TableRow>
                                                                                                        {contact?.Contact
                                                                                                            ?.ContactAddresses &&
                                                                                                            contact?.Contact?.ContactAddresses.map(
                                                                                                                (address, subindex) => (
                                                                                                                    <TableRow
                                                                                                                        key={subindex + 6}
                                                                                                                    >
                                                                                                                        <TableCell
                                                                                                                            style={
                                                                                                                                styles.cell
                                                                                                                            }
                                                                                                                        >
                                                                                                                            <MDTypography
                                                                                                                                fontSize={1}
                                                                                                                            >
                                                                                                                                <span
                                                                                                                                    style={{
                                                                                                                                        fontWeight:
                                                                                                                                            "700",
                                                                                                                                    }}
                                                                                                                                >
                                                                                                                                    {" "}
                                                                                                                                    {
                                                                                                                                        address
                                                                                                                                            ?.ContactAddressType
                                                                                                                                            ?.type_name
                                                                                                                                    }
                                                                                                                                    :{" "}
                                                                                                                                </span>
                                                                                                                            </MDTypography>
                                                                                                                        </TableCell>
                                                                                                                        <TableCell
                                                                                                                            style={
                                                                                                                                styles.cell
                                                                                                                            }
                                                                                                                        >
                                                                                                                            <MDTypography
                                                                                                                                fontSize={1}
                                                                                                                            >
                                                                                                                                {
                                                                                                                                    address?.contact_address
                                                                                                                                }
                                                                                                                            </MDTypography>
                                                                                                                        </TableCell>
                                                                                                                    </TableRow>
                                                                                                                )
                                                                                                            )}
                                                                                                    </TableBody>
                                                                                                </Table>
                                                                                            </MDBox>
                                                                                        )
                                                                                    )}
                                                                            </>
                                                                        ) : (
                                                                            <StackSkeleton />
                                                                        )}
                                                                    </>
                                                                )}
                                                                {index === 1 && (
                                                                    <>
                                                                        <MDBox>
                                                                            {!loader ? (
                                                                                <Box sx={{ marginBottom: 2 }}>
                                                                                    <Box sx={{ marginBottom: 2 }}>
                                                                                        <Table
                                                                                            style={{
                                                                                                ...styles.table,
                                                                                                marginTop: "5px",
                                                                                                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                                                                            }}
                                                                                        >
                                                                                            <MDTypography fontSize={1}>
                                                                                                <span style={{ fontWeight: "700" }}>Device Item</span>
                                                                                            </MDTypography>
                                                                                            <TableBody>
                                                                                                {/* Render Device Setup Fields */}
                                                                                                {[
                                                                                                    {
                                                                                                        label: "Depth",
                                                                                                        value: deviceSetupFields?.depth,
                                                                                                    },
                                                                                                    {
                                                                                                        label: "Width",
                                                                                                        value: deviceSetupFields?.width,
                                                                                                    },
                                                                                                    {
                                                                                                        label: "Length",
                                                                                                        value:
                                                                                                            deviceSetupFields?.length,
                                                                                                    },
                                                                                                    {
                                                                                                        label: "Shape",
                                                                                                        value: deviceSetupFields?.shape,
                                                                                                    },
                                                                                                ].map(
                                                                                                    (field, index) =>
                                                                                                        field.value && (
                                                                                                            <TableRow
                                                                                                                key={`setup-${index}`}
                                                                                                            >
                                                                                                                <TableCell
                                                                                                                    style={styles.cell}
                                                                                                                >
                                                                                                                    <MDTypography
                                                                                                                        fontSize={1}
                                                                                                                    >
                                                                                                                        <span
                                                                                                                            style={{
                                                                                                                                fontWeight: "700",
                                                                                                                            }}
                                                                                                                        >
                                                                                                                            {field.label}:
                                                                                                                        </span>
                                                                                                                    </MDTypography>
                                                                                                                </TableCell>
                                                                                                                <TableCell
                                                                                                                    style={styles.cell}
                                                                                                                >
                                                                                                                    <MDTypography
                                                                                                                        fontSize={1}
                                                                                                                    >
                                                                                                                        {field.value}
                                                                                                                    </MDTypography>
                                                                                                                </TableCell>
                                                                                                            </TableRow>
                                                                                                        )
                                                                                                )}

                                                                                                {/* Render Device Identifier Values */}
                                                                                                {device.attributes?.DeviceIdentifierValues?.map(
                                                                                                    (e, i) => (
                                                                                                        <TableRow
                                                                                                            key={`identifier-${i}`}
                                                                                                        >
                                                                                                            <TableCell
                                                                                                                style={styles.cell}
                                                                                                            >
                                                                                                                <MDTypography fontSize={1}>
                                                                                                                    <span
                                                                                                                        style={{
                                                                                                                            fontWeight: "700",
                                                                                                                        }}
                                                                                                                    >
                                                                                                                        {
                                                                                                                            e.DeviceIdentifierType
                                                                                                                                .identifier_type_name
                                                                                                                        }
                                                                                                                        :
                                                                                                                    </span>
                                                                                                                </MDTypography>
                                                                                                            </TableCell>
                                                                                                            <TableCell
                                                                                                                style={styles.cell}
                                                                                                            >
                                                                                                                <MDTypography fontSize={1}>
                                                                                                                    {e.value}
                                                                                                                </MDTypography>
                                                                                                            </TableCell>
                                                                                                        </TableRow>
                                                                                                    )
                                                                                                )}
                                                                                                {
                                                                                                    isShare ?
                                                                                                        <TableRow>
                                                                                                            <TableCell
                                                                                                                style={styles.cell}
                                                                                                            >
                                                                                                                <MDTypography fontSize={1}>
                                                                                                                    <span
                                                                                                                        style={{
                                                                                                                            fontWeight: "700",
                                                                                                                        }}
                                                                                                                    >
                                                                                                                        Public Share Device URL:
                                                                                                                    </span>
                                                                                                                </MDTypography>
                                                                                                            </TableCell>
                                                                                                            <TableCell
                                                                                                                style={styles.cell}
                                                                                                            >
                                                                                                                <MDTypography fontSize={1} style={{ cursor: 'pointer' }} onClick={() => copyToClipboard(`${location.origin}/device/public/${device.attributes?.PublicShareDevice?.public_uuid}`)}>
                                                                                                                    🔗
                                                                                                                </MDTypography>
                                                                                                            </TableCell>
                                                                                                        </TableRow>
                                                                                                        : <></>
                                                                                                }

                                                                                            </TableBody>
                                                                                        </Table>
                                                                                    </Box>
                                                                                    {
                                                                                        paramValue?.device_setup_details ?
                                                                                            <>
                                                                                                <Table
                                                                                                    style={{
                                                                                                        ...styles.table,
                                                                                                        marginTop: "5px",
                                                                                                        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                                                                                    }}
                                                                                                >
                                                                                                    <TableBody>
                                                                                                        {(!loader && parameters.length && paramValue?.device_setup_details) ? (
                                                                                                            parameters.map((e) => {
                                                                                                                if (show_device_setting.includes(e.parameter_name) && !cond.includes(paramValue.device_setup_details[e.parameter_name])) {
                                                                                                                    return (
                                                                                                                        <React.Fragment key={e.parameter_name}>
                                                                                                                            <TableRow key={e.parameter_name}>
                                                                                                                                <TableCell
                                                                                                                                    style={styles.cell}
                                                                                                                                    title={e.tooltip}
                                                                                                                                >
                                                                                                                                    <MDTypography fontSize={1}>
                                                                                                                                        <strong style={{ display: 'flex', alignItems: 'center', gap: '7px' }}>
                                                                                                                                            {e.Icon ? <i className={e.Icon.class_name}></i> : ''}
                                                                                                                                            {e.label}:
                                                                                                                                        </strong>
                                                                                                                                    </MDTypography>
                                                                                                                                </TableCell>
                                                                                                                                <TableCell
                                                                                                                                    style={styles.cell}
                                                                                                                                >
                                                                                                                                    <MDTypography fontSize={1}>
                                                                                                                                        {formatValue(paramValue.device_setup_details[`convert_${e.parameter_name}`] ?? paramValue.device_setup_details[e.parameter_name], e.format ?? '', e.display_ui ?? '')}
                                                                                                                                    </MDTypography>
                                                                                                                                </TableCell>
                                                                                                                            </TableRow>
                                                                                                                        </React.Fragment>
                                                                                                                    );
                                                                                                                }
                                                                                                                return <></>;
                                                                                                            })
                                                                                                        ) : ''}
                                                                                                    </TableBody>
                                                                                                </Table>
                                                                                            </>
                                                                                            : ''
                                                                                    }
                                                                                </Box>
                                                                            ) : (
                                                                                <StackSkeleton />
                                                                            )}
                                                                        </MDBox>
                                                                    </>
                                                                )}
                                                                {index === 2 && (
                                                                    <>
                                                                    </>
                                                                )}
                                                            </CardContent>
                                                        )}
                                                    </Card>
                                                </Grid>
                                            ))}
                                        </Grid>
                                    </MDBox>
                                    <Modal open={openModal} onClose={() => setOpenModal(false)}>
                                        <MDBox tabIndex={-1}>
                                            <GoogleMapComponent
                                                lat={gps.latitude}
                                                lng={gps.longitude}
                                                edit={false}
                                            />
                                        </MDBox>
                                    </Modal>
                                    <Grid item xs={12} sm={8} lg={4}>
                                        <Tabs
                                            value={selectedTab}
                                            orientation={tabsOrientation}
                                            onChange={handleTabChange}
                                            aria-label="Tabs"
                                            sx={{ display: "flex" }}
                                        >
                                            <Tab
                                                sx={{ flex: "1", p: "1" }}
                                                label={
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            p: "2",
                                                            alignItems: "center",
                                                            fontSize: { xs: "0.85rem", sm: "1rem" },
                                                            gap: { xs: "2px", sm: "8px" },
                                                        }}
                                                    >
                                                        <i
                                                            className="fas fa-file-alt"
                                                            style={{ marginRight: "2px" }}
                                                        ></i>
                                                        Logs
                                                    </Box>
                                                }
                                            />
                                            <Tab
                                                sx={{ flex: "1", p: "1" }}
                                                label={
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            p: "2",
                                                            alignItems: "center",
                                                            fontSize: { xs: "0.85rem", sm: "1rem" },
                                                            gap: { xs: "2px", sm: "8px" },
                                                        }}
                                                    >
                                                        <i
                                                            className="fas fa-exclamation-triangle"
                                                            style={{ marginRight: "1px" }}
                                                        ></i>
                                                        Alerts
                                                    </Box>
                                                }
                                            />
                                            <Tab
                                                sx={{ flex: "1", p: "1" }}
                                                label={
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            p: "2",
                                                            alignItems: "center",
                                                            fontSize: { xs: "0.85rem", sm: "1rem" },
                                                            gap: { xs: "2px", sm: "8px" },
                                                        }}
                                                    >
                                                        <i
                                                            className="fa-solid fa-clock"
                                                            style={{ marginRight: "1px" }}
                                                        ></i>
                                                        Events
                                                    </Box>
                                                }
                                            />
                                            <Tab
                                                sx={{ flex: "1", p: "1" }}
                                                label={
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            p: "2",
                                                            alignItems: "center",
                                                            fontSize: { xs: "0.85rem", sm: "1rem" },
                                                            gap: { xs: "2px", sm: "8px" },
                                                        }}
                                                    >
                                                        <i
                                                            className="fas fa-code-branch"
                                                            style={{ marginRight: "1px" }}
                                                        ></i>
                                                        Rules
                                                    </Box>
                                                }
                                            />
                                            <Tab
                                                sx={{ flex: "1.5", p: "2" }}
                                                label={
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            fontSize: { xs: "0.85rem", sm: "1rem" },
                                                            gap: { xs: "0px", sm: "8px" },
                                                        }}
                                                    >
                                                        <i
                                                            className="fas fa-tools"
                                                            style={{ marginRight: "0px" }}
                                                        ></i>
                                                        Service Request
                                                    </Box>
                                                }
                                            />
                                        </Tabs>
                                    </Grid>

                                    {selectedTab === 0 && Object.keys(reportType).length > 0 && (
                                        <LogsTable
                                            columns={dataTableData.columns}
                                            id={id}
                                            getRows={getRows}
                                            canSearch={true}
                                            canDelete={false}
                                            canExport={false}
                                            isSelection={false}
                                        />
                                    )}
                                    {selectedTab === 1 && (
                                        <>
                                            <Modal
                                                open={openViewModal}
                                                onClose={handleViewClose}
                                                aria-labelledby="modal-title"
                                                aria-describedby="modal-description"
                                            >
                                                <Card
                                                    sx={{
                                                        position: "absolute",
                                                        top: "50%",
                                                        left: "50%",
                                                        transform: "translate(-50%, -50%)",
                                                        width: "80%", // Set the desired width here
                                                        backgroundColor: "white",
                                                        boxShadow: 24,
                                                        p: 4,
                                                        maxHeight: "70vh", // Set max height to enable scrolling
                                                        overflowY: "auto",
                                                        overflowX: "hidden",
                                                    }}
                                                >
                                                    <CardContent>
                                                        <DynamicDataTable Alert={alert} />
                                                    </CardContent>
                                                </Card>
                                            </Modal>

                                            <MDBox pt={6} pb={3}>
                                                <MDBox mb={3}>
                                                    <CollapsibleTable
                                                        width="100%"
                                                        data={alertTableData}
                                                        columns={alertColumns}
                                                        clickViewHandler={clickViewHandler}
                                                        page={page}
                                                        setPage={setPage}
                                                        rowsPerPage={rowsPerPage}
                                                        setRowsPerPage={setRowsPerPage}
                                                        count={countRef.current}
                                                    />
                                                </MDBox>
                                            </MDBox>
                                        </>
                                    )}
                                    {selectedTab === 2 && (
                                        <>
                                            <EventsTable
                                                columns={eventdataTableData.columns}
                                                id={id}
                                                getRows={getEventRows}
                                                canSearch={true}
                                                canDelete={false}
                                                isSelection={false}
                                            />
                                        </>
                                    )}
                                    {selectedTab === 3 && (
                                        <>
                                            <DataTable
                                                table={alertRuledataTableData}
                                                canSearch={true}
                                            />
                                        </>
                                    )}
                                    {selectedTab === 4 && (
                                        <MDBox sx={{ marginTop: "20px" }}>

                                            <ServiceRequestDataTable
                                                table={serviceRequestdataTableData}
                                                canSearch={true}
                                            />
                                        </MDBox>
                                    )}
                                </MDBox>
                            </MDBox>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <JsonTree open={selectedLogInfo} onClose={() => setSelectedLogInfo(null)} data={selectedLogInfo} darkTheme={true} />
            <JsonTree open={openJsonTree} onClose={() => setJsonTree(false)} data={rawDataValue} />
            <Footer />
        </div>
    );
};

export default memo(PublicGateway);
